export class ControlStore {
  // store类型
  storeType: string = 'ControlStore';
  // 注册过来的store集合
  stores: any;

  constructor() {
    this.stores = {}
  }

  registerStore(key: string, newStore: any) {
    if (this.stores[key]) return
    this.stores[key] = newStore
  }

  getStore(key: string) {
    return this.stores[key]
  }
}